import * as React from "react";

import Header from "@common/components/Atoms/Header";
import Loading from "@common/components/Atoms/Loading";

interface PageExternalProps {
    title: string
    updatingMessage: string
    updating: boolean
}

export class PageExternal extends React.Component<PageExternalProps> {
    componentDidMount() {
        // Make sure we have ONE 'is-external' class on the body for internal pages
        //  NOTE: this does NOT make the browser "flash" since rendering happens later in the event loop
        document.body.classList.remove("is-external");
        document.body.classList.add("is-external");
    }

    render() {
        const classes = ["o-site", "o-site--external"];
        if(this.props.updating) classes.push("is-updating");

        return (
            <div>
                <Header title={this.props.title} />
                <div className={classes.join(" ")}>
                    {this.props.children}
                    <div className="o-site__updating">
                        <Loading message={this.props.updatingMessage} />
                    </div>
                </div>
            </div>
        );
    }
}
